/* Each instance owns its listener; custom elements also initialize after editor reloads. */
if (!customElements.get('br-getting-started-video')) {
  customElements.define(
    'br-getting-started-video',
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const button = this.querySelector('button');
        const template = this.querySelector('template');
        if (!button || !template) return;
        this.initialized = true;
        button.addEventListener(
          'click',
          () => {
            this.append(template.content.cloneNode(true));
            button.hidden = true;
            const player = this.querySelector('video, iframe');
            player.focus();
            if (player.tagName === 'VIDEO')
              player.play().catch(() => {
                /* Native controls remain available. */
              });
          },
          { once: true }
        );
      }
      disconnectedCallback() {
        this.querySelector('video')?.pause();
      }
    }
  );
}
